import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import { formatNumber } from "./formatNumber";
import i18next from "i18next";
import { BALANCE_RELOAD } from "../constant";

const MyBalance = () => {
  const memberData = useSelector((state) => state.isMemberInfo);
  const dispatch = useDispatch();

  const location = useLocation();

  const { pathname } = location;

  useEffect(() => {
    const fetchDataPeriodically = () => {
      dispatch({ type: "GET_BALANCE" });
    };

    const apiIterval = setInterval(() => {
      fetchDataPeriodically();
    }, BALANCE_RELOAD);

    return () => clearInterval(apiIterval);
  }, []);

  return pathname.includes("gamebox")
    ? `(${i18next.t("common.playing")})`
    : formatNumber(memberData?.vpoint, { point: false });
};

export default MyBalance;
